import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';

export const getTextEllipsisStyle = (lines: number): SxProps<Theme> => {
  return {
    overflow: 'hidden',
    maxHeight: `${lines * 1.5}rem`,
  };
};
